<template>
    <div v-if="store.isLoading" class="loading-modal">
      <div class="modal-content">
        <font-awesome-icon icon="spinner" spin />
        <p>Loading...</p>
      </div>
    </div>
  </template>
  
  <script>
  import { store } from '../store';
  
  export default {
    setup() {
      return { store };
    }
  };
  </script>
  
  <style scoped>
  .loading-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
  }
  </style>